












import { Component, Vue, Prop } from "vue-property-decorator";
import TooltipModule from "@/store/tooltip";

@Component
export default class CTooltip extends Vue {
  @Prop({ type: String, required: true })
  private msg!: string;

  @Prop({ type: String, required: false })
  private msg2!: string;

  @Prop({ type: Boolean, required: true, default: false })
  private show!: boolean;

  @Prop({ type: String, required: true })
  private tType!: string;

  private close() {
    if (this.tType === "error") {
      TooltipModule.commitIsShow(false);
    }
  }
}
